export const NO_CATEGORY = "none";
export const NO_CATEGORY_LABEL = "Sin categoría";

export const categoryOptions = (categories) => [...categories.map((c) => [c.id, c.name]), [NO_CATEGORY, NO_CATEGORY_LABEL]];

/** Services narrowed to a category filter value ("all" | "none" | id). */
export const servicesInCategory = (services, categoryId) => {
  if (!categoryId || categoryId === "all") return services;
  return services.filter((s) => (categoryId === NO_CATEGORY ? !s.category_id : s.category_id === categoryId));
};

/** [{ category, services }] in category order; services without (visible) category go last under "Otros". */
export const groupByCategory = (services, categories, otherLabel = "Otros") => {
  const groups = categories.map((c) => ({ category: c, services: services.filter((s) => s.category_id === c.id) })).filter((g) => g.services.length);
  const known = new Set(categories.map((c) => c.id));
  const rest = services.filter((s) => !known.has(s.category_id));
  return rest.length ? [...groups, { category: { id: NO_CATEGORY, name: otherLabel }, services: rest }] : groups;
};
